import "@assets/css/bootstrap-grid.css";
import { Spinner } from "@components/ui/spinner";
import { zodResolver } from "@hookform/resolvers/zod";
import { endpoint } from "@services/api.services";
import { useQueryClient } from "@tanstack/react-query";
import { SkeletonTwo } from "@ui/external/components/skeleton";
import { getInputField } from "@utils/function/index.function";
import { showToast, throwErrorAlert } from "@utils/helper/index.helper";
import { useHandleAction, usePathname } from "@utils/hook/index.hook";
import {
  BrandingFormData,
  BrandingFormSchema,
} from "@utils/interface/form.schema";
import { IndividualQuery, METHODS } from "@utils/interface/index.interface";
import { BrandingData, JourneyData } from "@utils/interface/journey.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { useSelectionStore } from "@utils/states/index.state";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
interface FormProps {
  refetch: () => void;
}
const BrandingForm: React.FC<FormProps> = () => {
  const { searchParams, handleAction } = useHandleAction({});
  const { type } = useParams();
  const pathname = usePathname();
  const queryClient = useQueryClient();
  const modalItem = searchParams.get("modal-item");
  const modalMode = searchParams.get("modal");
  const params = useParams();
  console.log("PArams", params);
  const defaultValue = {
    title: modalMode === "add" ? (searchParams.get("search") as string) : "",
    branding:
      modalMode === "add"
        ? params?.id
          ? [
              {
                label: params?.id,
                value: params?.id,
              },
            ]
          : []
        : [],
  };
  useEffect(() => {
    if (modalMode == "add") {
      reset({
        ...defaultValue,
      });
    }
  }, [modalMode]);
  console.log("errors de", defaultValue);
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm<BrandingFormData>({
    mode: "onChange",
    resolver: zodResolver(BrandingFormSchema),
  });
  console.log("🚀 ~ errors:", errors);

  const { data: fetchData, isPending: fetchPending } = useListData<
    IndividualQuery<BrandingData>
  >({
    endpoint: endpoint["branding"],
    key: `${pathname}-${modalItem}`,
    enabled: modalItem ? true : false,
    id: modalItem || "",
    window: false,
  });
  console.log("fetchData", fetchData);
  /* set default value */

  useEffect(() => {
    if (modalItem && fetchData?.data) {
      const { title, branding, image, certificate_template } = fetchData.data as any;
      console.log("fetchData.data", certificate_template);
      reset({
        title: title || "",
        // description: fetchData?.data?.description,
        certificate_template: [
          {
            label: certificate_template?.title,
            value: certificate_template?.id,
          },
        ],
        branding: [
          {
            label: branding,
            value: branding,
          },
        ],
        image: image || "",
      });
    } else {
      reset({});
    }
  }, [modalItem, reset, fetchData?.data]);
  const { setIsFormPending } = useSelectionStore();
  const handleMutate = (data: any) => {
    data = {
      ...data,
      certificate_template: data?.certificate_template?.[0].value,
      branding: data?.branding?.[0].value,
    };
    if (modalItem) {
      data = {
        ...data,
        id: modalItem,
      };
      if (!(data.image instanceof File || data.image instanceof Blob))
        delete data.image;
    }
    return {
      data,
      endpoint: endpoint["branding"],
      method: modalItem ? METHODS.PUT : METHODS.POST,
    };
  };
  const handleSuccess = async ({
    status,
  }: {
    data: JourneyData;
    status: number;
  }) => {
    if ([200, 201].includes(status)) {
      queryClient.invalidateQueries({ queryKey: [`${pathname}-listing`] });
      queryClient.invalidateQueries({
        queryKey: [`${pathname}-listing-scroll`],
      });
      queryClient.invalidateQueries({ queryKey: ["journey-section-listing"] });

      showToast({
        description: `${pathname.replace("-", " ")} ${
          status === 200 ? "Updated" : "Created"
        }`,
        type: "success",
        title: "Success",
      });

      handleAction({
        type: "modal-close",
      });
    } else {
      return new Error("Unknown API Error");
    }
  };
  const handleError = async (error: any) => {
    console.log(error, "error00");
    if (error?.data?.status == 413) {
      showToast({
        description: "File Size Too Large",
        type: "error",
        title: "Error",
      });
    }
    setIsFormPending(false);
    throwErrorAlert(error);
  };

  const { mutate, isPending } = usePostData();
  console.log("errors", errors);
  const onSubmit = (data: BrandingFormData) => {
    //Add Mutation Data
    mutate(handleMutate(data), {
      onSuccess: ({ data, status }) => handleSuccess({ data, status }),
      onError: (data) => handleError({ data }),
    });
  };

  // const { type } = useParams();

  console.log("Type", params);
  const formSchema = React.useMemo(
    () => [
      {
        name: "title",
        label: "Title",
        colSpan: 12,
        type: "text",
        placeholder: "Enter Title",
        control: control,
        setValue: setValue,
        errors,
        className: `mb-[20px] min-w-full w-full`,
        visable: true,
      },
      {
        name: "branding",
        type: "async",
        isMulti: false,
        label: "Branding",
        placeholder: "Select Branding",
        colSpan: 12,
        option: [
          {
            label: "signatures",
            value: "signatures",
          },
          {
            label: "logos",
            value: "logos",
          },
          {
            label: "stamps",
            value: "stamps",
          },
        ],
        control: control,

        setValue: setValue,
        errors,
        className: `mb-[20px] min-w-full w-full`,
        visable: true,
      },
      {
        name: "certificate_template",
        type: "async",
        isMulti: false,
        label: "Certificate Template",
        placeholder: "Select Certificate Template",
        colSpan: 12,
        endpoint: endpoint["templates"],
        control: control,
        format: { key: "title", value: "id" },

        setValue: setValue,
        errors,
        className: `mb-[20px] min-w-full w-full`,
        visable: true,
      },
      {
        name: "image",
        label: "Upload Image",
        colSpan: 12,
        type: "cropper",
        cropperWidthPlaceholder: 800,
        cropperHeightPlaceholder: 1180,
        cropperWidth: 200,
        cropperHeight: 200,
        upload_type: "image",
        control: control,
        setValue: setValue,
        errors,
        className: `mb-[20px] min-w-full w-full`,
        visable: true,
      },
      {
        type: "submit",
        value:
          isPending || (fetchPending && modalItem)
            ? `processing...`
            : `${modalMode || ""} ${(params?.id || type || pathname)?.replace(
                "-",
                " "
              )}`,
        className: "w-full h-[47px] mt-[32px] capitalize",
        colSpan: 12,
        variant: "default",
        endIcon: isPending ? <Spinner /> : null,
        disabled: isPending ? true : false,
        visable: true,
      },
    ],
    [setValue, control, errors, isPending]
  );

  if (fetchPending && modalItem)
    return (
      <>
        <SkeletonTwo />
      </>
    );
  return (
    <>
      
      <form onSubmit={handleSubmit(onSubmit)} className="row w-full">
        {formSchema.map(
          (field, index) =>
            (field.visable || field.visable == undefined) && (
              <div
                key={index}
                className={`col-lg-${field.colSpan} col-12 lg:px-[12px] px-[8px]`}
              >
                {getInputField({ ...field })}
              </div>
            )
        )}
      </form>
    </>
  );
};

export default BrandingForm;
